import * as yup from 'yup';
import yupPassword from 'yup-password';

yupPassword(yup);

// yup-password updates the prototype of several yup objects
// by using this yup object instead of pulling from the library we can ensure that the version of yup we import
// has been updated as needed by yupPassword

export default yup;
